import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { hubConnectionReducer } from 'src/app/root-store/hub-connection-store/hub-connection.reducer';
import { hubConnectionFeatureKey } from 'src/app/root-store/hub-connection-store/hub-connection.selectors';
import { HubConnectionEffects } from 'src/app/root-store/hub-connection-store/hub-connections.effects';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(hubConnectionFeatureKey, hubConnectionReducer),
        EffectsModule.forFeature([HubConnectionEffects])
    ]
})
export class HubConnectionStoreModule {}
